import React from "react"

import type { PublicOutfitterFieldsFragment } from "~graphql/generated/graphql"
import OutfitterHeader from "~components/pages/outfitter/outfitter-header"
import { CurrentOutfitterProvider } from "~components/providers/current-outfitter-provider"
import OutfitterDetails from "~components/pages/outfitter/outfitter-details"
import RecommendedOutfitters from "~components/pages/outfitter/recommended-outfitters"
import Divider from "~components/shared/divider"
import ResponsiveBlock from "~components/shared/responsive-block"

interface Props {
    readonly outfitter: PublicOutfitterFieldsFragment
}

export function OutfitterContent({ outfitter }: Props) {
    return (
        <CurrentOutfitterProvider outfitter={outfitter}>
            <OutfitterHeader outfitter={outfitter} />
            <OutfitterDetails />
            <ResponsiveBlock>
                <Divider margin />
                <RecommendedOutfitters
                    currentOutfitterSlug={outfitter.slug || ""}
                    state={outfitter.location?.state || ""}
                />
            </ResponsiveBlock>
        </CurrentOutfitterProvider>
    )
}
